import { Currency } from '../models/currency.model';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';
import { httpService } from './httpService';


class CurrencyService extends GenericService<Currency, ListItem> {
  constructor() {
    super('/api/Currency');
  }

}


export const currencyService = new CurrencyService();